const ShowAlert = (type, message, enqueueSnackbar) => {
  enqueueSnackbar(message, {variant: type});
}

export default ShowAlert;
